import React from 'react'

function Galeria({img1, img2, img3, img4}) {
  return (
    <div className="w-full columns-2 gap-4 space-y-4">
            <img
              className="w-full h-[400px] object-cover rounded-lg"
              src={img1}
              alt=""
            />
            <img
              className="h-[200px] w-full object-cover object-bottom rounded-lg"
              src={img2}
              alt=""
            />
            <img
              className="h-[200px] w-full object-cover rounded-lg"
              src={img3}
              alt=""
            />
            <img
              className="h-[400px] w-full object-cover rounded-lg"
              src={img4}
              alt=""
            />
          </div>
  )
}

export default Galeria